import * as React from 'react';
import Button from '../button/button';
import styles from './footer.module.css';

export const Disclosure: React.StatelessComponent<any> = props => {
	const urlToFetchSupportedBrowsersContent = window.location.origin + '/eWMLogin/SupportedBrowsers/SupportedBrowsers';
	return (
		<div className="text-lg font-roboto">
			<div id="printDisclouser">
				<div>
					<iframe id="iframeDisclosure" allowFullScreen
						height="100%" width="100%"
						src={urlToFetchSupportedBrowsersContent}
						className={styles.iframeContent}
					>
					</iframe>
				</div>
				{/* <p className="font-bold">Keep Your Browser Current for the Best eWealthManager Experience</p>
				<p className="my-3.5">
					To provide you with the best eWealthManager experience possible, we support Microsoft Edge, Internet
					Explorer 11, and the two latest non-beta versions of Chrome, Firefox and Safari. Although you may
					still use an older browser version on eWealthManager, you may not have access to all available
					features.
				</p>

				<p className="font-bold">
					Download the latest browser from the following browser development websites:
				</p>
				<table className="my-3.5">
					<tbody>
						<tr className="my-3.5">
							<td>
								<span className="sb-bold-content">Chrome:</span>
							</td>
							<td>
								<a
									href="https://www.google.com/intl/en/chrome/browser"
									className={styles.sb_browser_link}
									rel="noreferrer"
									target="_blank">
									https://www.google.com/intl/en/chrome/browser
								</a>
							</td>
						</tr>
						<tr className="my-3.5">
							<td>
								<span className="sb-bold-content">Edge:</span>
							</td>
							<td>Available updates will be downloaded and installed automatically</td>
						</tr>
						<tr className="my-3.5">
							<td>
								<span className="sb-bold-content">Firefox:</span>
							</td>
							<td>
								<a
									href="http://www.mozilla.org/en-US/firefox/new"
									className={styles.sb_browser_link}
									rel="noreferrer"
									target="_blank">
									http://www.mozilla.org/en-US/firefox/new
								</a>
							</td>
						</tr>
						<tr className="my-3.5">
							<td>
								<span className="sb-bold-content">Internet Explorer:</span>
							</td>
							<td>
								<a
									href="http://windows.microsoft.com/en-us/internet-explorer/download-ie"
									className={styles.sb_browser_link}
									rel="noreferrer"
									target="_blank">
									http://windows.microsoft.com/en-us/internet-explorer/download-ie
								</a>
							</td>
						</tr>
						<tr className="my-3.5">
							<td>
								<span className="sb-bold-content">Safari:</span>
							</td>
							<td>
								<a
									href="http://support.apple.com/downloads#safari"
									className={styles.sb_browser_link}
									rel="noreferrer"
									target="_blank">
									http://support.apple.com/downloads#safari
								</a>
							</td>
						</tr>
					</tbody>
				</table>

				<p className="font-bold mt-3.5">Mobile Devices</p>
				<p>
					eWealthManager is best viewed on a desktop PC. You may access the website on a mobile device, but
					may not have access to all available features.{' '}
				</p>

				<p className="font-bold mt-3.5">Update Settings and Tools</p>
				<p>
					Please enable cookies and JavaScript on your browser. If applicable, the "compatibility mode" must
					also be disabled. We also recommend using current versions of Adobe Acrobat Reader and Adobe Flash
					Player.{' '}
				</p> */}
			</div>
			<div className={styles.btnFlex}>
				<Button
					onClick={props.onCloseModalClick}
					name="CLOSE"
					text="CLOSE"
					disabled={false}
					className={styles.closeBtn}></Button>
				<Button
					onClick={props.onPrintModalClick}
					name="PRINT"
					text="PRINT"
					disabled={false}
					className={styles.printBtn}></Button>
			</div>
		</div>
	);
};

export default Disclosure;
